module.exports = __webpack_public_path__ + "static/media/Drilling.22641140.mp3";